import { createContext } from "react";
import { Cart } from "./LineItem";

const CartContext = createContext<Cart | null>(null);

export { CartContext };
